import { createBrowserRouter, Navigate } from 'react-router-dom'
import { lazyWithRetry } from 'utils/lazyWithRetry'
import { ROUTE_MAP } from 'constants/index'
import NavWrapper from 'components/NavWrapper/NavWrapper'
import RootErrorBoundary from 'components/RootErrorBoundary'

const HomePage = lazyWithRetry(() => import('pages/HomePage/HomePage'))
const CoursePage = lazyWithRetry(() => import('pages/CoursePage/CoursePage'))
const IgNewsPage = lazyWithRetry(() => import('pages/IgNewsPage/IgNewsPage'))
const IgContentPage = lazyWithRetry(() => import('pages/IgNewsPage/IgContentPage'))
const ServicePage = lazyWithRetry(() => import('pages/ServicePage/ServicePage'))
const AboutPage = lazyWithRetry(() => import('pages/AboutPage/AboutPage'))
const ArticlePage = lazyWithRetry(() => import('pages/ArticlePage/ArticlePage'))
const ArticleContentPage = lazyWithRetry(() => import('pages/ArticlePage/ArticleContentPage'))
const QAPage = lazyWithRetry(() => import('pages/QAPage/QAPage'))
const ContactPage = lazyWithRetry(() => import('pages/ContactPage/ContactPage'))
const CoopPage = lazyWithRetry(() => import('pages/CoopPage/CoopPage'))

const Routes = createBrowserRouter([
  {
    path: '/',
    element: <NavWrapper />,
    errorElement: <RootErrorBoundary />,
    children: [
      //      { index: true, element: <Navigate to={`/${ROUTE_MAP.IG_NEWS.key}`} replace /> },
      //      { path: 'home', element: <HomePage /> },
      { index: true, element: <HomePage /> },
      { path: `/${ROUTE_MAP.COURSE.key}`, element: <CoursePage /> },
      {
        path: `/${ROUTE_MAP.IG_NEWS.key}`,
        element: <IgNewsPage />,
        children: [
          {
            path: ':igNewsId',
            element: <IgContentPage />,
          }
        ]
      },
      { path: `/${ROUTE_MAP.SERVICE.key}`, element: <ServicePage /> },
      { path: `/${ROUTE_MAP.ABOUT_US.key}`, element: <AboutPage /> },
      {
        path: `/${ROUTE_MAP.ARTICLE.key}`,
        element: <ArticlePage />,
        children: [
          {
            path: ':articleId',
            element: <ArticleContentPage />,
          }
        ]
      },
      { path: `/${ROUTE_MAP.QA.key}`, element: <QAPage /> },
      { path: `/${ROUTE_MAP.COOPERATION.key}`, element: <CoopPage /> },
      { path: `/${ROUTE_MAP.COOPERATION.key}/:customerId`, element: <CoopPage /> },
      { path: `/${ROUTE_MAP.CONTACT.key}`, element: <ContactPage /> },
    ]
  },
  { path: '*', element: <Navigate to='/' replace /> },
])

export default Routes
